import { useState } from "react";
import { useLocation } from "react-router-dom";
import style from "../../styles/inputGrid.module.css";
import { GetInsumos } from "../../actions/Insumo";
import { Estado } from "../../actions/Estado";
import { TipoInsumo } from "../../actions/tipoinsumo";
import formStyle from "../../styles/form.module.css";
import { useQueryClient } from "@tanstack/react-query";
import ImagenCerrar from "../../images/cerrar.png";
import "../../styles/comprastyles.css"; 
// const itemsList = [
//   { id: 1, descripcion: "Item A", stock: 10, dolar: 100 },
//   { id: 2, descripcion: "Item B", stock: 5, dolar: 200 },
//   { id: 3, descripcion: "Item C", stock: 8, dolar: 150 },
// ];
export default function ItemForm() {
   var entorno = "grabo";
   if (localStorage.getItem("user") === 'admin'){ 
      entorno = "no grabo";
   }
   const hoy = new Date();
   const location = useLocation();
   const token = localStorage.getItem("token");
   const queryClient = useQueryClient();
   const { state } = location;
   const itemsList = GetInsumos();
    const estados = Estado();
    const tipoinsu = TipoInsumo();
   const [inputs, setInputs] = useState({});
   const [cart, setCart] = useState([]);
   const [ttitulo, setTtitulo] = useState("");
   const [showInsumoModal, setShowInsumoModal] = useState(false);
   const [cpres, setCpres] = useState(true);
   const [insumoInput, setInsumoInput] = useState({
      descripcion: "",
      dolar: 0,
      stock: 0,
      cod_status: "1",
      presentacion: 1,
      consumo: 0,
      unimed: 1,
      presdescrip: "",
      tipo: 2,
      porcentajeganancia: 2,
   });
   const urlCompra = process.env.REACT_APP_URL_DIR 

   const numberFormat = new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   });

   var verInsumo = false
   // eslint-disable-next-line no-unused-vars
   const [input, setInput] = useState({
      tabla: state ? state.tabla : "",
      id: state ? state.id : 0,
      id_primary: state ? state.id_primary : 0,
      fecha: hoy.toISOString().split("T")[0],
      tipo: 2,
      titulo: state ? state.titulo : "",
      total: state ? state.total : 0,
      compra: state ? state.compra : [],
      hecho: 0,
   });
   console.log("input: ", input);
   // Pongo datos de la compra
   if (input.id_primary > 0 && cart.length === 0 && input.hecho === 0) {
      console.log("input.compra: ", input.compra);
      setTtitulo(input.titulo)
      // const newcart = input.compra.map((compraItem) => ({
      //    id: compraItem.id,
      //    tipo: compraItem.tipo,
      //    descripcion: compraItem.descripcion,
      //    presentacion: compraItem.presentacion,
      //    porcentaje: compraItem.porcentaje,
      //    amount: compraItem.compratattooinsumo.cantidad,
      //    dolar: parseFloat(compraItem.compratattooinsumo.precio),
      //    total: parseFloat(compraItem.compratattooinsumo.precio),
      // }));
      const newcart = input.compra.map((compraItem) => {
         const amount = compraItem.compratattooinsumo.cantidad;
         const dolar = parseFloat(compraItem.compratattooinsumo.precio);
         console.log('compraItem.tipo: ', compraItem.tipo);
         console.log('amount: ', amount);
         console.log('dolar: ', dolar);
         console.log('compraItem.presentacion: ', compraItem.presentacion);
         let total;
         if (compraItem.presentacion === 1) {
            total = dolar / amount;
         } else {
            console.log('amount / dolar: ', dolar / amount);
            total = parseFloat(
               (compraItem.consumo * dolar) / compraItem.presentacion / amount               
            );
         }
         console.log('total: ', total);
         return {
            id: compraItem.id,
            tipo: compraItem.tipo,
            descripcion: compraItem.descripcion,
            presentacion: compraItem.presentacion,
            porcentaje: compraItem.porcentaje,
            amount,
            dolar,
            total,
         };
      });
      // Populate inputs for each item in newcart
      const newInputs = {};
      newcart.forEach((item) => {
         console.log("item: ", item);
         newInputs[item.id] = {
            amount: item.amount,
            dolar: item.dolar,
         };
      });
      setInputs(newInputs);

      console.log("newcart: ", newcart);
      setCart(newcart);

      console.log("inputs: ", inputs);
      input.hecho = 1;
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      console.log("cart: ", cart);
      const url =
         input.id === 0
            ? urlCompra + input.tabla
            : process.env.REACT_APP_URL_DIR + `sqlraw/compra`;
      const metodo = input.id === 0 ? "POST" : "PUT";
      input.titulo = ttitulo || "Compra de Insumos";
      input.total = cart.reduce((acc, item) => acc + item.dolar, 0).toFixed(2);
      input.compra = cart.map((item) => ({
         id: item.id,
         cantidad: item.amount,
         precio: item.dolar,
         total: item.total,
         presentacion: item.presentacion,
         porcentaje: item.porcentaje,
      }));
      console.log("input.total : ", input);
      console.log("url: ", metodo, url);
      fetch(url, {
         method: metodo,
         body: JSON.stringify(input),
         headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
         },
      }).then((res) => res.json());
      input.titulo = "";
      input.total = 0;
      input.insumos = [];
      input.compra = [];
      if (entorno === "grabo") {
         window.location.href = "/CompraInst";
      }
   };

   const handleInputChange = (id, field, value) => {
      const newInputs = {
         ...inputs,
         [id]: {
            ...inputs[id],
            [field]: value,
         },
      };
      setInputs(newInputs);
      
      const item = itemsList.find((i) => i.id === id);
      const amount = parseFloat(newInputs[id]?.amount || 0);
      const newdolar = parseFloat(newInputs[id]?.dolar || item.dolar);
      
      if (amount > 0) {
         const updatedItem = {
            id,
            descripcion: item.descripcion,
            presentacion: item.presentacion,
            porcentaje: item.porcentaje,
            stock: item.stock,
            amount,
            dolar: newdolar,
            total: newdolar / amount 
         };
         if (item.presentacion !== 1) {     // esto es unidad
            // console.log("newdolar: ", newdolar);
            // console.log("amount: ", amount);
            // console.log("item: ", item.tipo);
            // console.log("presentacion: ", item.presentacion);
            // console.log("1: ", newdolar / amount);
            // console.log("2: ", (newdolar / amount) * item.presentacion);
            // updatedItem.total = parseFloat(
            //    ((newdolar / amount) * item.presentacion) / 100
            // );
            console.group('Datos');
            console.log('item: ', item)
            console.log('newdolar: ', newdolar);
            console.log('amount: ', amount);
            console.log('Precio Unitario: ', newdolar*amount);
            console.log('presentacion: ', item.presentacion);
            console.log('consumo: ', item.consumo);
            console.log('Precio Unitario: ', (item.consumo*newdolar)/item.presentacion/amount);
            console.groupEnd();
            updatedItem.total = parseFloat(
               ((item.consumo*newdolar)/item.presentacion/amount)
            );
            console.log('item.tipo: ', item.tipo);
            console.log("updatedItem.total: ", updatedItem.total);
         }

         const exists = cart.find((c) => c.id === id);
         if (exists) {
            setCart(cart.map((c) => (c.id === id ? updatedItem : c)));
         } else {
            setCart([...cart, updatedItem]);
         }
      }
   };

   const removeFromCart = (id) => {
      setCart(cart.filter((item) => item.id !== id));
      setInputs({ ...inputs, [id]: { amount: "", dolar: "" } });
   };

   const openInsumoModal = () => {
      setInsumoInput({
         descripcion: "",
         dolar: 0,
         stock: 0,
         cod_status: "1",
         presentacion: 1,
         consumo: 0,
         unimed: 1,
         presdescrip: "",
         tipo: 1,
         porcentajeganancia: 2,
      });
      setCpres(true);
      setShowInsumoModal(true);
   };

   const closeInsumoModal = () => {
      setShowInsumoModal(false);
   };

   const handleInsumoChange = (e) => {
      const { name, value } = e.target;
      if (name === "unimed") {
         if (parseInt(value) === 1) {
            setCpres(true);
         } else {
            setCpres(false);
         }
      }
      setInsumoInput({
         ...insumoInput,
         [name]: value,
      });
   };

   const getTituloMedida = () => {
      if (parseInt(insumoInput.unimed) === 1) return "Unidad";
      if (parseInt(insumoInput.unimed) === 2) return "Mililitros";
      if (parseInt(insumoInput.unimed) === 3) return "Gramos";
      if (parseInt(insumoInput.unimed) === 4) return "Metros";
      return "";
   };

   const saveInsumo = async (e) => {
      e.preventDefault();

      if (parseInt(insumoInput.unimed) > 1) {
         if (
            insumoInput.consumo === "" ||
            insumoInput.presentacion === "" ||
            parseFloat(insumoInput.consumo) <= 0 ||
            parseFloat(insumoInput.presentacion) <= 0 ||
            parseFloat(insumoInput.consumo) > parseFloat(insumoInput.presentacion)
         ) {
            alert("Revise consumo y presentación del insumo");
            return;
         }
      }

      const payload = {
         ...insumoInput,
         unimed: parseInt(insumoInput.unimed),
         tipo: parseInt(insumoInput.tipo),
         cod_status: parseInt(insumoInput.cod_status),
         presentacion:
            parseInt(insumoInput.unimed) === 1
               ? 1
               : parseFloat(insumoInput.presentacion),
         consumo:
            parseInt(insumoInput.unimed) === 1
               ? 0
               : parseFloat(insumoInput.consumo),
         dolar: parseFloat(insumoInput.dolar || 0),
         stock: parseFloat(insumoInput.stock || 0),
      };

      const urlInsumo = process.env.REACT_APP_URL_DIR + "insumo";
      const res = await fetch(urlInsumo, {
         method: "POST",
         body: JSON.stringify(payload),
         headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
         },
      });

      if (!res.ok) {
         alert("No se pudo guardar el insumo");
         return;
      }

      await queryClient.invalidateQueries({ queryKey: ["Insumo"] });
      closeInsumoModal();
   };
   console.log("cart: ", cart);
   return (
      <div className="form-container">
         <div className="list">
            <div className="title-row">
               <h2>Insumos Tattoo</h2>
               <button onClick={openInsumoModal}>Nuevo Insumo</button>
            </div>
            <table>
               <thead>
                  <tr>
                     <th>Descripcion</th>
                     <th>Precio por Unidad</th>
                     <th>Stock</th>
                     <th colSpan={2}>Cantidad de unidades</th>
                     <th>Precio Total</th>
                  </tr>
               </thead>
               <tbody>
                  {itemsList?.map((item) => {
                     verInsumo= false
                     if (input.tabla === "compratattoo" && item.tipo === 2) verInsumo=true
                     if (input.tabla === "compra" && item.tipo === 1) verInsumo=true
                     if (item.tipo === 3) verInsumo=true
                     if (verInsumo) {
                        return (
                           <tr key={item.id}>
                              <td className={style.tdleft}>
                                 {item.descripcion}
                              </td>
                              <td className={style.precio}>
                                 $&nbsp;{numberFormat.format(item.dolar)}
                              </td>
                              <td className={style.precio}>
                                 {item.stock}&nbsp;
                              </td>
                              <td>
                                 <input
                                    type="number"
                                    value={inputs[item.id]?.amount || ""}
                                    onChange={(e) =>
                                       handleInputChange(
                                          item.id,
                                          "amount",
                                          e.target.value
                                       )
                                    }
                                 />
                              </td>
                              <td className={style.tdotro}>
                                 &nbsp;{item.presdescrip}&nbsp;
                              </td>
                              <td>
                                 <input
                                    type="number"
                                    value={inputs[item.id]?.dolar || ""}
                                    onChange={(e) =>
                                       handleInputChange(
                                          item.id,
                                          "dolar",
                                          e.target.value
                                       )
                                    }
                                 />
                              </td>
                           </tr>
                        );
                     } 
                     return null;
                  })}
               </tbody>
            </table>
         </div>

         <div className="list">
            <h2>Insumos Seleccionados</h2>
            <table>
               <thead>
                  <tr>
                     <th>Descripcion</th>
                     <th>Cantidad</th>
                     <th>Total</th>
                     <th>Valor Unidad</th>
                     <th>Accion</th>
                  </tr>
               </thead>
               <tbody>
                  {cart?.map((item) => (
                     <tr key={item.id}>
                        <td className={style.tdleft}>{item.descripcion}</td>
                        <td className={style.precio}>{item.amount}</td>
                        <td className={style.precio}>$&nbsp;{numberFormat.format(item.dolar)}</td>
                        <td className={style.precioLong}>
                           $&nbsp;{item.total.toFixed(2)}
                           &nbsp;
                        </td>
                        <td>
                           <img
                              onClick={() => removeFromCart(item.id)}
                              src={ImagenCerrar}
                              height="30px"
                              alt=""
                           />
                           {/* <button onClick={() => removeFromCart(item.id)}>Remove</button> */}
                        </td>
                     </tr>
                  ))}
                  {cart.length === 0 && (
                     <tr>
                        <td colSpan="5">Seleccione un item</td>
                     </tr>
                  )}
               </tbody>
               {cart.length > 0 && (
                  <>
                     <tr>
                        <td colSpan="2">Total:</td>
                        <td>
                           $&nbsp;
                           {numberFormat.format(cart
                              .reduce((acc, item) => acc + item.dolar, 0)
                              .toFixed(2))}
                        </td>
                        <td colSpan="2"></td>
                     </tr>
                     <tr>
                        <td>Descripcion</td>
                        <td colSpan={5}>
                              <input
                                 className={style.inputDescripcion}
                                 type="text"
                                 placeholder="Titulo de la compra"
                                 value={ttitulo}
                                 onChange={(e) => setTtitulo(e.target.value)}
                              />
                        </td>
                     </tr>
                     <tr>
                        <td colSpan="2">
                           <button onClick={(e) => handleSubmit(e)}>
                              Realizar Compra
                           </button>
                        </td>
                        <td colSpan="2">&nbsp;</td>
                        <td>
                           <button
                              onClick={() => {
                                 window.location.href = "/CompraInst";
                              }}
                           >
                              VOLVER
                           </button>
                        </td>
                     </tr>
                  </>
               )}
            </table>
         </div>

         {showInsumoModal && (
            <div className="modal-overlay" onClick={closeInsumoModal}>
               <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <h2>Datos del Insumo</h2>
                  <form onSubmit={saveInsumo}>
                     <div className={formStyle.input_group}>
                        <span className={formStyle.input_group_text}>Insumo: </span>
                        <input
                           className={formStyle.input_field}
                           type="text"
                           placeholder="Descripcion Insumo"
                           name="descripcion"
                           value={insumoInput.descripcion}
                           onChange={handleInsumoChange}
                           required
                        />
                     </div>

                     <div className={formStyle.input_group}>
                        <span className={formStyle.input_group_text}>Presentación: </span>
                        <input
                           className={formStyle.input_field}
                           type="text"
                           placeholder="Botella, Caja, Bidon..."
                           name="presdescrip"
                           value={insumoInput.presdescrip}
                           onChange={handleInsumoChange}
                           required
                        />
                     </div>

                     <div className={formStyle.input_group}>
                        <span className={formStyle.input_group_text}>Unidad de medida:</span>
                        <select
                           name="unimed"
                           id="unimed"
                           onChange={handleInsumoChange}
                           value={insumoInput.unimed}
                           className={formStyle.input_field}
                        >
                           <option value="0">Seleccionar</option>
                           <option value="1">Unidad</option>
                           <option value="2">Mililitros</option>
                           <option value="3">Gramos</option>
                           <option value="4">Metros</option>
                        </select>
                     </div>

                     {!cpres || parseInt(insumoInput.unimed) > 1 ? (
                        <div className={formStyle.input_group}>
                           <span className={formStyle.input_group_text}>
                              Total {getTituloMedida()}
                           </span>
                           <input
                              type="number"
                              id="presentacion"
                              name="presentacion"
                              value={insumoInput.presentacion}
                              onChange={handleInsumoChange}
                              className={formStyle.input_field_number}
                           />
                           <span className={formStyle.input_group_text}>
                              {getTituloMedida()} que se utilizan
                           </span>
                           <input
                              type="number"
                              id="consumo"
                              name="consumo"
                              value={insumoInput.consumo}
                              onChange={handleInsumoChange}
                              className={formStyle.input_field_number}
                           />
                        </div>
                     ) : null}

                     <div className="d-flex p-1">
                        <div className={formStyle.input_group}>
                           <span className={formStyle.input_group_text}>Precio por Unidad:</span>
                           <p className={formStyle.p_group_text}>{insumoInput.dolar}</p>
                        </div>
                        <div className={formStyle.input_group}>
                           <span className={formStyle.input_group_text}>Stock:</span>
                           <p className={formStyle.p_group_text}>{insumoInput.stock}</p>
                        </div>
                     </div>

                     <div className={formStyle.input_group}>
                        <span className={formStyle.input_group_text}>Tipo de Insumo:</span>
                        <select
                           name="tipo"
                           id="tipo"
                           onChange={handleInsumoChange}
                           value={insumoInput.tipo}
                           className={formStyle.input_field}
                        >
                           <option value="0">Seleccionar</option>
                           {tipoinsu &&
                              tipoinsu.map((ins) => (
                                 <option value={ins.id} key={ins.id}>{`${ins.nombre}`}</option>
                              ))}
                        </select>
                     </div>

                     <div className={formStyle.input_group}>
                        <span className={formStyle.input_group_text}>Status:</span>
                        <select
                           name="cod_status"
                           id="cod_status"
                           onChange={handleInsumoChange}
                           value={insumoInput.cod_status}
                           className={formStyle.input_field}
                        >
                           <option value="0">Seleccionar</option>
                           {estados &&
                              estados.map((dat) => (
                                 <option value={dat.id} key={dat.id}>{`${dat.nombre}`}</option>
                              ))}
                        </select>
                     </div>

                     <div className="modal-actions">
                        <button className={formStyle.inputBtnNew} type="submit">
                           AGREGAR
                        </button>
                        <button className={formStyle.inputBtnNew} type="button" onClick={closeInsumoModal}>
                           CERRAR
                        </button>
                     </div>
                  </form>
               </div>
            </div>
         )}
      </div>
   );
}
